import { ListConfig } from 'components/List/types';

export const listConfig: ListConfig = {
  cellSpacing: 1,
  columns: [
    { xs: 2 },
    { xs: 2 },
    { container: true, justify: 'flex-end', xs: 1 },
    { container: true, justify: 'flex-end', xs: 2 },
    { container: true, justify: 'flex-end', xs: 2 },
    { container: true, justify: 'flex-end', xs: 1 },
    { container: true, justify: 'flex-end', xs: 2 },
  ],
};
